<template>
  <div class="column">
    <div class="columns">
      <div class="column is-flex">
        <div v-if="groupButtons" class="field is-grouped">
          <span v-for="(btn, idx) of groupButtons" :key="idx" class="control">
            <button :disabled="isDisabled(btn.disabled, rowData)" :key="btn.event" v-tooltip="btn.tooltip"
              class="button has-text-black-bis" @click="onCellClicked($event, btn.event)"
              v-if="!isDisabledOnPermission(btn)">
              <span class="icon">
                <i :class="btn.icon"></i>
              </span>
            </button>
          </span>
        </div>
        <o-dropdown v-if="menu && menu.length" aria-role="list" @active-change="activeChanged"
          class="is-action-dropdown" :disabled="rowData?.isDisabled">
          <template #trigger>
            <button class="button">
              <span class="icon">
                <i class="icon-more"></i>
              </span>
            </button>
          </template>
          <o-dropdown-item v-for="(opt, idx) in menu" :key="idx" @click="onCellClicked($event, opt.event)"
            :class="[{disabledPer: isDisabled3Dot(opt)}]"
            :disabled="disableOptions(opt, rowData)" aria-role="listitem">
            <span class="line-height is-flex is-align-items-center">
              <span v-if="opt.icon" class="icon mr-1">
                <i :class="opt.icon"></i>
              </span>
              <span>{{ opt.label }}</span>
            </span>
          </o-dropdown-item>
          <o-dropdown-item class="control">
            <button class="button has-background-white">
              <i class="icon-close"></i>
            </button>
          </o-dropdown-item>
        </o-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { get, isFunction } from 'lodash';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: 'data-table-action-fields',
  props: {
    rowData: {
      type: Object,
      default: () => ({}),
    },
    rowField: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cell-clicked'],
  setup(props, { emit }) {

    const { getPermissionValues } = PermissionMixin();

    const menu = computed(() => {
      const actions = get(props.rowField, 'inputProps.options', false);
      if (props.rowField?.inputProps && isFunction(props.rowField?.inputProps.options)) {
        return actions(props.rowData);
      }
      return actions;
    });




    const disableOptions = (option, item) => {
      if (isFunction(option.isDisabled)) {
        return option.isDisabled(item);
      }
      return false;
    };

    const onCellClicked = (event, type) => {
      emit('cell-clicked', { type, data: props.rowData });
    };

    const groupButtons = computed(() => {
      // check if the input props has groupButtons
      if (props.rowField.inputProps
        && isFunction(props.rowField.inputProps.groupButtons)) {
        return props.rowField.inputProps.groupButtons(props.rowData);
      }
      return false;
    });

    const activeChanged = (active) => {
      emit('cell-clicked', { data: props.rowData, type: 'three-dot', active });
    };

    const isDisabled = (disabled, row) => {
      if (isFunction(disabled)) {
        return disabled(row);
      }
      return disabled;
    }

    const isDisabled3Dot = (opt) => getPermissionValues({
      permissionModule: opt.permissionModule,
      type: opt.alterDataKey,
    });

    const isDisabledOnPermission = (opt) => getPermissionValues({
      permissionModule: opt.permissionModule,
      type: opt.alterDataKey,
    });

    return {
      disableOptions,
      menu,
      onCellClicked,
      groupButtons,
      activeChanged,
      isDisabled,
      isDisabled3Dot,
      isDisabledOnPermission
    }
  }
}
</script>
